(function () {
  if (window.__rcFreeShippingProgressInit) return;
  window.__rcFreeShippingProgressInit = true;

  function calculateTotal(cart) {
    var priceForItems = cart.items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);

    var cartDiscount = (cart.cart_level_discount_applications || []).reduce(
      function (sum, discountAllocation) {
        var discountApp = discountAllocation.discount_application || discountAllocation;
        return sum + (discountApp.total_allocated_amount || 0);
      },
      0
    );

    return Math.max(priceForItems - cartDiscount, 0);
  }

  function updateBar(bar, cart, total) {
    // Actualiza la barra de progreso, si existe en este elemento
    var progressEl = bar.querySelector('[data-rc-fsb-progress]');
    if (progressEl) {
      var threshold = parseFloat(progressEl.getAttribute('data-threshold')) * 100;
      var fill = progressEl.querySelector('.rc-fsb-progress__fill');
      if (fill && threshold) {
        var percentage = Math.min((total / threshold) * 100, 100);
        fill.style.width = percentage + '%';
      }
    }

    // Alterna entre mensaje "carrito vacío" y mensaje normal (solo aplica
    // a las barras que traen data-unreached-empty, ej. la de arriba)
    if (bar.hasAttribute('data-unreached-empty')) {
      var newMessage = cart.item_count === 0
        ? bar.getAttribute('data-unreached-empty')
        : bar.getAttribute('data-unreached-normal');

      if (newMessage) {
        bar.setAttribute('unreached-message', newMessage);
      }

      // El componente nativo solo re-renderiza el texto cuando cambia
      // "total-price", no cuando cambia "unreached-message". Forzamos
      // un cambio real (valor distinto, y luego el correcto) para que
      // el componente recalcule el mensaje con el texto ya actualizado.
      bar.setAttribute('total-price', '-1');
      bar.setAttribute('total-price', String(total));
    }
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail.cart;
    var total = calculateTotal(cart);

    document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
      updateBar(bar, cart, total);
    });
  });
})();